import React from 'react'
import { Loader } from '@manychat/manyui'

export function SuspensePageLoading() {
  return (
    <div className="h-full d-flex align-center justify-center">
      <Loader center />
    </div>
  )
}
